import { http } from '../shared/api';
import { requireEfSyncStatusUrl } from '../shared/api/operationStatusUrl';

export const listEmissionFactors = (params) => http.get('/api/emission-factors', { params });

export const createEmissionFactor = (body) => http.post('/api/emission-factors', body);

export const publishCorrection = (id, body, etag) => http.put(
  `/api/emission-factors/${id}`,
  body,
  { headers: { 'If-Match': etag } },
);

export const updateEmissionFactorStatus = (id, status, reason, etag) => http.patch(
  `/api/emission-factors/${id}/status`,
  { status, reason },
  { headers: { 'If-Match': etag } },
);

export const getEmissionFactorHistory = (id) => http.get(`/api/emission-factors/${id}/history`);

/** Enqueue a manual operation; execution continues independently of this tab. */
export const syncEmissionFactors = (request, idempotencyKey) => http.post(
  '/api/emission-factors/sync',
  {
    force: Boolean(request.force),
    fiscal_year: request.fiscalYear ?? null,
    source_types: request.sourceTypes || null,
    source_file_ids: request.sourceFileIds || null,
  },
  {
    headers: { 'Idempotency-Key': idempotencyKey },
  },
);

/** The backend selects the completed Japanese reporting year; the UI confirms it. */
export const getEmissionFactorSyncPolicy = () => http.get(
  '/api/emission-factors/sync-policy',
);

export const getEmissionFactorSyncStatus = (statusUrl, operationId, requestConfig) => {
  const endpoint = requireEfSyncStatusUrl(statusUrl, operationId);
  return requestConfig ? http.get(endpoint, requestConfig) : http.get(endpoint);
};

export const listEmissionFactorSyncHistory = (fiscalYear) => http.get(
  '/api/emission-factors/sync-history',
  { params: { fiscal_year: fiscalYear } },
);

/** Authenticated stream; private Blob URI never leaves the backend. */
export const downloadSourceFile = (id) => http.download(
  `/api/emission-factors/source-files/${id}/download`,
);

export function uploadSourceFile(file, { fiscalYear, sourceType = 'DB_V3' }) {
  const form = new FormData();
  form.append('file', file);
  form.append('fiscal_year', String(fiscalYear));
  form.append('source_type', sourceType);
  return http.upload('/api/emission-factors/source-files', form);
}
